import { Navigate, Route, Routes } from "react-router-dom";
import TailwindMasterLayout from "../layouts/master/MasterLayout";
import CampaignPage from "../layout/campaign/CampaignPage";
import CampaignReportPage from "../layout/campaign/CampaignReportPage";
import CampaignEditor from "../layout/campaign/campaign-create/CampaignEditor";
import OrderExport from "../layout/order/order-export/OrderExport";
import OrderExportInfo from "../layout/order/order-export/OrderExportInfo";
import ProcessPage from "../layout/order/process-order/ProcessPage";
import StorefrontListPage from "../layout/product-management/StorefrontListPage";
import ProductListPage from "../layout/product-management/product/ProductListPage";
import BasicProductInformation from "../layout/product-management/product/product-create/components/BasicProductInformation";
import SelectCompanyAndMarketplace from "../layout/product-management/product/product-create/components/CompanyAndMarketplace";
import { default as MediaUpload } from "../layout/product-management/product/product-create/components/MediaUpload";
import ProductCategoryAttributes from "../layout/product-management/product/product-create/components/ProductCategoryAttributes";
import ProductSummary from "../layout/product-management/product/product-create/components/ProductSummary";
import ProductVariantsCategory from "../layout/product-management/product/product-create/components/ProductVariantsCategory";
import ProductVariantsList from "../layout/product-management/product/product-create/components/ProductVariantsList";
import ProductWeight from "../layout/product-management/product/product-create/components/ProductWeight";
import Shipments from "../layout/product-management/product/product-create/components/Shipments";
import StorefrontName from "../layout/product-management/storefront/storefront-create/components/StorefrontName";
import StorefrontSelectMarketplace from "../layout/product-management/storefront/storefront-create/components/StorefrontSelectMarketplace";
import StorefrontSummary from "../layout/product-management/storefront/storefront-create/components/StorefrontSummary";
import TemplatePage from "../layout/template/TemplatePage";
import WABAAccountsListPage from "../layout/user-menu/settings/WABAAccount/WABAAccountsPage";
import WABASignUp from "../layout/user-menu/settings/WABAAccount/account-create/components/WABASignUp";
import WABASummary from "../layout/user-menu/settings/WABAAccount/account-create/components/WABASummary";
import WABAVerify from "../layout/user-menu/settings/WABAAccount/account-create/components/WABAVerify";
import MarketplaceListPage from "../layout/user-menu/settings/Marketplace/MarketplacePage";
import MobileNavigation from "../layout/user-menu/settings/nav/MobileNavigation";
import User, { ClientData } from "../models/User";
import { About } from "../pages/About";
import { ContactDetail } from "../pages/ContactDetail";
import { Faq } from "../pages/FAQ";
import HomePage from "../pages/Home";
import { UserChat } from "../pages/UserChat";
import { APISetting } from "../layout/user-menu/settings/api-setting";
import MemberListPage from "../layout/user-menu/settings/user-management/MemberPage";
import AddMember from "../layout/user-menu/settings/user-management/add-member/AddMember";
import MarketplaceEditPage from "../layout/user-menu/settings/Marketplace/MarketplaceEditPage";
import NewListPage from "../components/list/_example_/New_Page_Example";
import NewOrderPage from "../layout/order/new-orderlist/NewOrderPage";
import TemplateUpdateCreate from "../layout/template/new-template-create/configuration";
import NewContactPage from "../layout/contact-management/new-contact-list/NewContactPage";
import CIQNewList from "../layout/ciq-management/ciq-newlist/CIQNewList";
import { HandleChat } from "../pages/HandleChat";
import ShippinghandoverPage from "../layout/order/shipping-handover/ShippinghandoverPage";
import ValuePackPage from "../layout/order/value-pack/ValuePack";
import ProductListingPage from "../modules/product/pages/ProductListingPage";
import ImportStockPage from "../modules/product/pages/ImportStockPage";
import {
  MerchantProductPage,
  AddEditMerchantProductPage,
} from "../modules/merchant-product";
import ChatListInitializer from "../modules/chat/redux/ChatIntitializer";
import { settingsRoutes } from "src/app/modules/setting/routes";
import { AppRoute } from "src/types";

export function isUserDataCompleted(userData?: User) {
  if (
    userData &&
    userData.id &&
    userData.id !== "" &&
    (userData.avatar || userData.avatar === "") &&
    (userData.name || userData.name === "")
  ) {
    return true;
  } else {
    return false;
  }
}

export const isClientDataCompleted = (client?: ClientData): boolean => {
  if (
    client &&
    client.id &&
    (client.avatar || client.avatar === "") &&
    (client.clientName || client.clientName === "")
  ) {
    return true;
  } else {
    return false;
  }
};

const PrivateRoutes = () => {
  //function to render routes with children
  const renderRoutes = (route: AppRoute, key: number) => (
    <Route key={key} path={route.path} element={route.element}>
      {route.children && route.children.map(renderRoutes)}
    </Route>
  );

  return (
    <>
      <ChatListInitializer />
      <Routes>
        {/* Remove old MasterLayout routes - now handled by TailwindMasterLayout */}

        <Route element={<TailwindMasterLayout />}>
          <Route path="auth/*" element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Navigate to="/home" />} />
          <Route path="product/listing" element={<ProductListingPage />} />
          <Route path="product/merchant" element={<MerchantProductPage />} />
          <Route
            path="product/merchant/create"
            element={<AddEditMerchantProductPage />}
          />
          <Route
            path="product/merchant/edit/:productId"
            element={<AddEditMerchantProductPage />}
          />
          <Route path="about" element={<About />} />
          <Route path="faq" element={<Faq />} />
          <Route path="contact/*" element={<NewContactPage />} />
          <Route path="ciq/*" element={<CIQNewList />} />
          <Route path="list-component/*" element={<NewListPage />} />
          <Route path="contact/detail/*" element={<ContactDetail />} />
          <Route path="handled-customer" element={<HandleChat />} />
          <Route path="user-conversation" element={<UserChat />} />
          <Route path="campaign/create" element={<CampaignEditor />} />
          <Route
            path="campaign/:campaignId/edit/*"
            element={<CampaignEditor />}
          />
          <Route
            path="campaign/:campaignId/report/*"
            element={<CampaignReportPage />}
          />
          <Route path="campaign/report/*" element={<CampaignReportPage />} />
          <Route path="campaign/*" element={<CampaignPage />} />
          <Route path="template/*" element={<TemplatePage />} />
          <Route path="template/create" element={<TemplateUpdateCreate />} />
          <Route path="template/update/*" element={<TemplateUpdateCreate />} />
          <Route path="storefront/*" element={<StorefrontListPage />} />
          <Route
            path="storefront/create-storefront/storefront-name"
            element={<StorefrontName />}
          />
          <Route
            path="storefront/create-storefront/select-marketplace"
            element={<StorefrontSelectMarketplace />}
          />
          <Route
            path="storefront/create-storefront/summary"
            element={<StorefrontSummary />}
          />
          <Route
            path="storefront/update-storefront/:id"
            element={<StorefrontSummary />}
          />
          <Route path="product/import-stock" element={<ImportStockPage />} />
          <Route path="product/*" element={<ProductListPage />} />
          <Route
            path="product/create-product/media-upload"
            element={<MediaUpload />}
          />
          <Route
            path="product/create-product/package-weight"
            element={<ProductWeight />}
          />
          <Route
            path="product/create-product/shipments"
            element={<Shipments />}
          />
          <Route
            path="product/create-product/select-company-and-marketplace"
            element={<SelectCompanyAndMarketplace />}
          />
          <Route
            path="product/create-product/category-attributes"
            element={<ProductCategoryAttributes />}
          />
          <Route
            path="product/create-product/variants-category"
            element={<ProductVariantsCategory />}
          />
          <Route
            path="product/create-product/variants-list"
            element={<ProductVariantsList />}
          />
          <Route
            path="product/create-product/summary"
            element={<ProductSummary />}
          />
          <Route
            path="product/create-product/basic-information"
            element={<BasicProductInformation isSummary={false} />}
          />
          <Route
            path="product/update/package-weight"
            element={<ProductWeight />}
          />
          <Route path="product/update/shipments" element={<Shipments />} />
          <Route
            path="product/update/select-company-and-marketplace"
            element={<SelectCompanyAndMarketplace />}
          />
          <Route
            path="product/update/category-attributes"
            element={<ProductCategoryAttributes />}
          />
          <Route
            path="product/update/variants-category"
            element={<ProductVariantsCategory />}
          />
          <Route
            path="product/update/variants-list"
            element={<ProductVariantsList />}
          />
          <Route path="product/update/media-upload" element={<MediaUpload />} />
          <Route path="product/update/summary" element={<ProductSummary />} />
          <Route
            path="product/update/basic-information"
            element={<BasicProductInformation isSummary={false} />}
          />
          <Route path="product/update/:id" element={<ProductSummary />} />
          <Route path="/setting/" element={<MobileNavigation />} />
          <Route
            path="/setting/waba-account/*"
            element={<WABAAccountsListPage />}
          />
          <Route
            path="/setting/waba-account/create/sign-up"
            element={<WABASignUp />}
          />
          <Route
            path="/setting/waba-account/create/verify"
            element={<WABAVerify />}
          />
          <Route
            path="/setting/waba-account/create/summary"
            element={<WABASummary />}
          />
          <Route
            path="/setting/marketplace/edit/:id"
            element={<MarketplaceEditPage />}
          />
          <Route
            path="/setting/marketplace/*"
            element={<MarketplaceListPage />}
          />
          <Route path="/setting/api" element={<APISetting />} />
          <Route path="/setting/user-management" element={<MemberListPage />} />
          <Route
            path="/setting/user-management/add-member"
            element={<AddMember />}
          />
          {settingsRoutes.map((route, index) => renderRoutes(route, index))}
          <Route path="order/*" element={<NewOrderPage />} />
          <Route path="order/process" element={<ProcessPage />} />
          <Route path="order/export" element={<OrderExport />} />
          <Route
            path="order/shippingHandover"
            element={<ShippinghandoverPage />}
          />
          <Route path="order/prePack" element={<ValuePackPage />} />
          {/* <Route path="order/export/download" element={<OrderExportDownload />} /> */}
          <Route
            path="order/export/information"
            element={<OrderExportInfo />}
          />
          <Route path="home" element={<HomePage />} />
          <Route path="*" element={<Navigate to="/error" />} />
        </Route>
      </Routes>
    </>
  );
};

export { PrivateRoutes };
